import {createTheme as createMuiTheme} from '@material-ui/core/styles';
import createColor from 'utils/material';

const contrastThreshold = 3;
const tonalOffset = 0.2;

const options = {
  direction: 'rtl',
  palette: {
    primary: {
      main: '#2383c0',
    },
    secondary: {
      main: '#294e79',
    },
    error: {
      main: '#ff0000',
    },
    warning: {
      main: '#f0ad4e',
    },
    info: {
      main: '#62B1F6',
    },
    success: {
      main: '#10d0a0',
      contrastText: '#ffffff',
    },
    notice: createColor('#ffe000', contrastThreshold, tonalOffset),
    gray: createColor('#cccccc', contrastThreshold, tonalOffset),
    contrastThreshold,
    tonalOffset,
  },
  typography: {
    fontFamily: 'IRANSans',
  },
  overrides: {
    MuiAppBar: {
      root: {
        '& h6': {
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
        },
      },
    },
    MuiGrid: {
      container: {
        width: '100% !important',
        margin: '0 !important',
      },
    },
    MuiBottomNavigationAction: {
      root: {
        paddingLeft: 0,
        paddingRight: 0,
        minWidth: 50,
      },
      label: {
        fontSize: 8,
        '&$selected': {
          fontSize: 10,
        },
      },
    },
    MuiLink: {
      root: {
        color: 'inherit',
      },
    },
  },
};

const theme = createMuiTheme(options);

export const themeLtr = createMuiTheme({
  ...options,
  direction: 'ltr',
});

export default theme;
